import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CoreButton from 'frontcore/components/CoreButton.vue'
import i18n from 'frontcore/i18n'
import UseSSOLogin from 'frontcore/domain/authorization/view/UseSSOLogin'
import { AuthorizationSSOConfiguration } from 'frontcore/domain/authorization/model/types'
import { computed, watch } from 'vue'

type Props = {
  applicationId?: string
  configuration: AuthorizationSSOConfiguration
  isFetchingUserConfiguration: boolean
}
type Emits = {
  (e: 'error', message: string): void,
  (e: 'loginSuccess'): void,
}

export default /*@__PURE__*/_defineComponent({
  __name: 'AuthorizationSSO',
  props: {
    applicationId: {},
    configuration: {},
    isFetchingUserConfiguration: { type: Boolean }
  },
  emits: ["error", "loginSuccess"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { t } = i18n.global

const ssoLoginUseCase = new UseSSOLogin(props.configuration, emit, props.applicationId)
const { login, loading } = ssoLoginUseCase.use()

const isLoginButtonLoading = computed<boolean>(() => {
  return loading.value || (loading.value && props.isFetchingUserConfiguration)
})

watch(
  () => props.isFetchingUserConfiguration,
  (newValue, oldValue) => {
    if (newValue || newValue === oldValue) { return }
    loading.value = newValue
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CoreButton, {
    disabled: _ctx.isFetchingUserConfiguration,
    label: _unref(t)('login.messages.corporate_title', { corporate_title: 'SSO' }),
    loading: isLoginButtonLoading.value,
    buttonType: "secondary",
    dataTest: "authorization-sso-login-button",
    type: "submit",
    onClick: _unref(login)
  }, null, 8, ["disabled", "label", "loading", "onClick"]))
}
}

})